import { FC } from 'react'
import { Notification } from '@wellesley/openapi'
import { AppsLink } from '@wellesley/router'
import { capitalize } from 'lodash/fp'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

const getActionTarget = ({ type, post }: Notification) => {
  const isReply =
    (type === 'LIKE' && !!post?.path?.length) ||
    (type === 'COMMENT' && post?.path && post.path.length > 1) ||
    (type === 'REPOST' && post?.originalPost?.path.length)

  return isReply ? 'reply' : 'post'
}

const getContent = (notification: Notification) => {
  const target = getActionTarget(notification)

  switch (notification.type) {
    case 'COMMENT':
      return <span>Replied to your {target}</span>
    case 'FOLLOW':
      return <span>Started following you</span>
    case 'FOLLOW_REQUEST':
      return <span>Requested following you</span>
    case 'LIKE':
      return <span>liked your {target}</span>
    case 'MENTION':
      return <span>Mentioned you</span>
    case 'EVENT_INVITE':
      return (
        <span>
          Invited you to <EventName notification={notification} />
        </span>
      )

    case 'EVENT_JOIN':
      return <span>Joined an event</span>
    case 'EVENT_CANCEL':
      return <span>Canceled an event</span>
    case 'EVENT_UPDATE':
      return <span>Updated an event</span>
    case 'REPOST':
      return notification.post?.text ? (
        <span>Quoted your {target}</span>
      ) : (
        <span>Reposted your {target}</span>
      )
    case 'POLL_VOTE':
      return <span>Voted on your poll</span>
    default:
      return null
  }
}

type NotificationTitleProps = {
  notification: Notification
}

const EventName: FC<NotificationTitleProps> = ({ notification }) => {
  const eventName = notification.event?.name
  const eventId = notification.event?.id
  const organizerUsername = notification.event?.organizer
    ? getUserNameWithDomain(notification.event?.organizer)
    : null

  if (!eventName || !eventId || !organizerUsername) {
    return null
  }

  return (
    <AppsLink
      to="/@/:username/events/:eventId"
      className="text-blue-600 hover:underline"
      props={{ eventId, username: organizerUsername }}
    >
      {capitalize(eventName)}
    </AppsLink>
  )
}

const NotificationTitle: FC<NotificationTitleProps> = ({ notification }) => {
  const content = getContent(notification)
  if (!content) return null

  return <div className="empty:hidden">{content}</div>
}

export default NotificationTitle
